<template>
  <div>
    <Form :isNewConfirmation="true" :isReEvaluation="true" />
  </div>
</template>

<script>
import Form from '../shared/Form.vue'

export default {
  components: {
    Form,
  }
}
</script>